import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center">
      <XCircle className="w-14 h-14 mx-auto text-[#C47A53]" />
      <h1 className="mt-6 font-serif text-3xl sm:text-4xl text-[#1A2621]">Checkout cancelled</h1>
      <p className="mt-2 text-[#5A6B61]">No charge was made. You can enroll whenever you're ready.</p>
      <button data-testid="back-dashboard-btn" onClick={() => navigate("/dashboard")} className="mt-8 px-8 py-4 rounded-full bg-[#2C4A3E] text-[#FAF8F5] font-semibold hover:bg-[#223B31]">
        Back to dashboard
      </button>
    </div>
  );
}
